import { SavedTextInputState, VoiceRecordingStatus } from "../types/AIChat/AiChatVoiceInput";

// Whether the voice session may still be discarded by the user: everything up to and
// including transcription is abortable, "sending" is past the commit point (the message
// may already be persisted server-side) and "idle" has nothing to cancel.
export const canCancelVoiceRecording = (status: VoiceRecordingStatus): boolean =>
  ["requestingPermission", "recording", "transcribing"].includes(status);

// Inserts the transcript at the text selection captured when recording started, replacing any
// selected text. Adds a single space on either side only where two word/punctuation characters
// would otherwise collide (Unicode-aware, so umlauts count as word characters), clamps the saved
// selection to the current text length, and returns the cursor position right after the insert.
export const insertTranscriptIntoText = (
  saved: SavedTextInputState,
  transcript: string,
): { text: string; cursorPosition: number } => {
  const selectionStart = Math.max(0, Math.min(saved.selectionStart, saved.text.length));
  const selectionEnd = Math.max(selectionStart, Math.min(saved.selectionEnd, saved.text.length));
  const before = saved.text.slice(0, selectionStart);
  const after = saved.text.slice(selectionEnd);
  const startsWithWordCharacter = /^[\p{L}\p{N}]/u;
  const endsWithText = /[\p{L}\p{N},.;:!?…)}\]»”’]$/u;
  const separatorBefore = endsWithText.test(before) && startsWithWordCharacter.test(transcript) ? " " : "";
  const separatorAfter = endsWithText.test(transcript) && startsWithWordCharacter.test(after) ? " " : "";

  return {
    text: before + separatorBefore + transcript + separatorAfter + after,
    cursorPosition: before.length + separatorBefore.length + transcript.length,
  };
};
